import { PARTNERS_TRANSITION_BANNER_DISMISSED } from '~~/constants/localStorage';
import isStringTrue from '~~/helpers/dataStructure/isStringTrue';
import { Logger } from '~~/helpers/logger';
import { StringBoolean } from '~~/types/StringBoolean';

export const usePartnersTransitionBanner = () => {

  const { isOnPartnersPage } = useIsPage();
  const { isLoggedIn } = useUserExtended();
  const { isLoyaltyDiscountEnabled } = useStoreVsfExtended();

  const isDismissed = useState<boolean>('partnersTransitionBannerDismissed', () => true);

  const isVisible = computed(() =>
    isLoyaltyDiscountEnabled.value && isLoggedIn.value && isOnPartnersPage.value && !isDismissed.value);

  const readStoredDismissal = (): boolean => {

    try {

      return isStringTrue(localStorage.getItem(PARTNERS_TRANSITION_BANNER_DISMISSED));

    } catch (error) {

      Logger.error('Failed to read the Partners transition banner dismissal from localStorage:', error);

      return false;

    }

  };

  const storeDismissal = () => {

    try {

      localStorage.setItem(PARTNERS_TRANSITION_BANNER_DISMISSED, StringBoolean.true);

    } catch (error) {

      Logger.error('Failed to save the Partners transition banner dismissal to localStorage:', error);

    }

  };

  const syncWithLocalStorage = () => {

    if (!import.meta.client) {

      return;

    }

    isDismissed.value = readStoredDismissal();

  };

  const dismiss = () => {

    isDismissed.value = true;
    storeDismissal();

  };

  return {
    isVisible,
    syncWithLocalStorage,
    dismiss,
  };

};
